import _ from 'lodash';
import React, {Fragment, useCallback, useState} from 'react';
import {Field, InjectedFormProps, reduxForm} from 'redux-form';
import block from 'bem-cn-lite';
import {compose} from 'recompose';

import {Button} from '@yandex-data-ui/common';
import {FormFieldText} from '@yandex-data-ui/cloud-components';
import {HTML} from '@doc-tools/components';

import withTranslation, {WithTranslationProps} from 'hoc/withTranslation';

import validate from './validate';
import axios from 'axiosWrapper';

import './SubscriptionForm.scss';

export interface SubscriptionFormFields {
    email: string;
}

export interface SubscriptionFormOwnProps {
    agreement?: string;
    onSubmit?: () => void;
}

type SubscriptionFormProps = SubscriptionFormOwnProps &
    InjectedFormProps<SubscriptionFormFields, SubscriptionFormOwnProps> &
    WithTranslationProps;

export interface SubscriptionFormState {
    isSubscribed: boolean;
    isError: boolean;
}

const b = block('SubscriptionForm');

const SubscriptionForm: React.FC<SubscriptionFormProps> = ({
    agreement,
    handleSubmit,
    i18nK,
    onSubmit: onSubmitExternal,
}) => {
    const [isSubscribed, setIsSubscribed] = useState(false);
    const [isError, setIsError] = useState(false);

    const onSubmit = useCallback(
        async (data: SubscriptionFormFields) => {
            try {
                if (onSubmitExternal) {
                    onSubmitExternal();
                }

                await axios.post('/form/subscribe', data);
                setIsSubscribed(true);
                setIsError(false);
            } catch (e) {
                setIsError(true);
            }
        },
        [onSubmitExternal],
    );

    const renderSubscribed = () => (
        <div className={b('subscribed')}>{i18nK('subscription-form_success')}</div>
    );

    const renderForm = () => (
        <Fragment>
            <form
                onSubmit={handleSubmit((values: SubscriptionFormFields) => onSubmit(values))}
                className={b('form')}
            >
                <div className={b('controls')}>
                    <Field
                        name="email"
                        component={FormFieldText}
                        className={b('input')}
                        placeholder={i18nK('subscription-form_email-placeholder')}
                        size="l"
                    />
                    <Button className={b('reg-button')} view="outlined" size="l" type="submit">
                        {i18nK('subscription-form_action')}
                    </Button>
                </div>
                {isError && <div className={b('error')}>{i18nK('subscription-form-error')}</div>}
                {agreement && (
                    <HTML className={b('agreement')} block={true}>
                        {agreement}
                    </HTML>
                )}
            </form>
        </Fragment>
    );

    return <div className={b()}>{isSubscribed ? renderSubscribed() : renderForm()}</div>;
};

export default compose<SubscriptionFormProps, SubscriptionFormOwnProps>(
    withTranslation('forms'),
    reduxForm({
        form: 'subscription-form',
        initialValues: {
            email: '',
        },
        validate,
    }),
)(SubscriptionForm);
